import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../redux/store";

export function GuestGuard() {
  const { isLoggedIn } = useAppSelector((state) => state.auth);

  if (!isLoggedIn) {
    return <Outlet />;
  }

  return <Navigate to="/" />;
}
